// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"7954c893","158":"0a517b6a","251":"f588a826","290":"df73ae2d","337":"7c8c9c2b","453":"efd8d5f3","592":"b44ec39d"}[chunkId] + ".chunk.js";
};